import axios from 'axios'
import Swal from 'sweetalert2'
import { publicData } from '@/router/defineVar'

export const state = () => ({
  geoCache: {},
})

export const getters = {
  getGeoData: (state) => (key) => state.geoCache[key],
}


export const mutations = {
  setGeoData(state, { key, data }) {
    state.geoCache = {
      ...state.geoCache,
      [key]: data,
    }
  },
}

export const actions = {
    async fetchGeoData({ state, commit }, { level, filters }) {
        let key = level
        if (level == 'province'){
            key += `-${filters.selectedProvince?._id.PROVINCE_ID}`
        }
        else if (level == 'district' || level == 'subdistrict'){
            key += `-${filters.selectedDistrict?._id.AMPHUR_ID}`
        } 
        
        if (state.geoCache[key]) {
            return state.geoCache[key]
        }

        let geoUrl
        if (level == 'province') {
            geoUrl = `${publicData.apiURL}map/amphur/sme/${filters.selectedProvince?._id.PROVINCE_ID}`
        } else if (level == 'district' || level == 'subdistrict') {
            geoUrl = `${publicData.apiURL}map/tambol/sme/${filters.selectedDistrict?._id.AMPHUR_ID}`
        } else {
            geoUrl = `${publicData.apiURL}map/province/sme`
        }

        try {
            const res = await axios.get(geoUrl)
            commit('setGeoData', { key, data: res.data })
            return res.data
        } catch (e) {
            Swal.fire({
                text: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
                icon: 'warning',
                timer: 3000,
                confirmButtonText: 'ปิด',
            })
            return []
        }
    }
}

